import { css } from 'src/styles/theme';
import { IInputProps } from './Input';

export const StylesDS = css<IInputProps>``;
